import { apiFetch } from "./api.js";

export const SORTEO_STATES = new Set(["borrador", "programado", "cerrado", "ejecutado", "anulado"]);
const validId = value => /^[1-9][0-9]*$/.test(String(value ?? ""));
function invalid() { throw new Error("Nitro devolvió datos de sorteos que no pudimos verificar."); }
function validateDraw(draw) {
  if (!draw || !validId(draw.id) || typeof draw.titulo !== "string" || !SORTEO_STATES.has(draw.estado)) invalid();
  return draw;
}
export function parseSorteosList(data) {
  if (!data || !Array.isArray(data.draws) || !data.pagination || typeof data.pagination !== "object" || Array.isArray(data.pagination) || !(data.pagination.nextCursor == null || typeof data.pagination.nextCursor === "string" || Number.isSafeInteger(data.pagination.nextCursor))) invalid();
  return { ...data, draws: data.draws.map(validateDraw) };
}
export function parseSorteoAudit(data) {
  if (!data || !Array.isArray(data.participantes) || !Array.isArray(data.auditoria)) invalid();
  validateDraw(data.sorteo);
  return data;
}
export function createSorteosTransport(request = apiFetch) {
  return {
    async list({ cursor = null, signal } = {}) {
      const params = new URLSearchParams({ limit: "50" });
      if (cursor != null) params.set("cursor", String(cursor));
      return parseSorteosList(await request(`/api/v1/sorteos?${params}`, { signal, cache: "no-store", timeoutMs: 10000 }));
    },
    async audit(id, { signal } = {}) {
      if (!validId(id)) invalid();
      const data = parseSorteoAudit(await request(`/api/v1/sorteos/${encodeURIComponent(id)}/auditoria`, { signal, cache: "no-store", timeoutMs: 10000 }));
      if (String(data.sorteo.id) !== String(id)) invalid();
      return data;
    },
  };
}
export function mergeSorteos(previous, incoming) {
  const ids = new Set(incoming.map(draw => String(draw.id)));
  return [...incoming, ...previous.filter(draw => !ids.has(String(draw.id)))];
}
export function newlyExecutedSorteos(previous, next, announced = new Set()) {
  const before = new Map(previous.map(draw => [String(draw.id), draw.estado]));
  return next.filter(draw => ["programado", "cerrado"].includes(before.get(String(draw.id))) && draw.estado === "ejecutado" && draw.ganador_nombre && !announced.has(String(draw.id)));
}
export function sorteosSummary(data) {
  const summary = data.summary;
  if (summary && [summary.active, summary.executed, summary.tickets].every(value => Number.isSafeInteger(Number(value)) && Number(value) >= 0)) return summary;
  if (data.pagination?.nextCursor != null) return null;
  return {
    active: data.draws.filter(draw => ["programado", "cerrado"].includes(draw.estado)).length,
    executed: data.draws.filter(draw => draw.estado === "ejecutado").length,
    tickets: data.draws.reduce((total, draw) => total + Number(draw.total_tickets || 0), 0),
  };
}
export function countdownLabel(date, now = Date.now()) {
  if (!date) return "Sin fecha programada";
  const timestamp = new Date(date).getTime();
  if (!Number.isFinite(timestamp)) return "Fecha por confirmar";
  const seconds = Math.floor((timestamp - now) / 1000);
  if (seconds <= 0) return "En proceso de publicación";
  const days = Math.floor(seconds / 86400);
  const hours = Math.floor(seconds % 86400 / 3600);
  const minutes = Math.floor(seconds % 3600 / 60);
  return `${days ? `${days}d ` : ""}${hours}h ${minutes}m ${String(seconds % 60).padStart(2, "0")}s`;
}
export function sorteoDate(value) {
  const date = value ? new Date(value) : null;
  return date && Number.isFinite(date.getTime()) ? new Intl.DateTimeFormat("es-CO", { dateStyle: "medium", timeStyle: "short", timeZone: "America/Bogota" }).format(date) : "Sin fecha";
}
